import { api } from '../lib/api';
import type { Parent } from '../lib/types';
import { useParent } from './ParentContext';

/**
 * Which family you're working in (#506), for someone in more than one (#652: from the top bar, not just Settings). The
 * children, the pages that span them and the plan all follow it, so switching reloads the app in the new family.
 */
export function FamilySwitcher({ compact = false, reloadTo }: { compact?: boolean; reloadTo?: string }) {
  const { parent, toast } = useParent();
  const families = parent.families ?? [];
  if (families.length < 2) return null;
  async function pick(familyId: string) {
    try {
      await api.put<Parent>('/api/me/active-family', { familyId });
      window.location.assign(reloadTo ?? window.location.pathname);
    } catch (e) {
      toast({ text: (e as Error).message, tone: 'alert' });
    }
  }
  return (
    <label className={compact ? 'family-switcher topbar-family' : 'family-switcher'}>
      <span className={compact ? 'sr-only' : undefined}>Family</span>
      <select value={parent.activeFamilyId ?? ''} onChange={(e) => void pick(e.target.value)} aria-label="The family you’re working in">
        {families.map((f) => (
          <option key={f.id} value={f.id}>
            {f.name}
          </option>
        ))}
      </select>
    </label>
  );
}
